import type { User } from "@/schema"

export const MAX_VISIBLE_BOOKS = 5

export function orderedBooksForUser(user: User) {
  const booksById = new Map(user.books.map((book) => [book.id, book]))
  const savedIds = user.sidebar_book_ids ?? []
  const topBook = user.default_book ?? user.principal_books?.[0]
  const preferredIds = savedIds.length ? savedIds : topBook ? [topBook.id] : []
  const orderedBooks = preferredIds.flatMap((id) => {
    const book = booksById.get(id)
    booksById.delete(id)
    return book ? [book] : []
  })
  return [...orderedBooks, ...booksById.values()]
}
